import CloseIcon from '@mui/icons-material/Close';
import { Alert, AlertTitle, IconButton, Typography } from '@mui/material'
import { styled } from '@mui/material/styles'
import { Box } from '@mui/system'
import i18n from 'i18next'
import PropTypes from 'prop-types'
import React from 'react'
import { useSelector } from 'react-redux'
import { BeatLoader } from 'react-spinners'
import AppButton from '../components/AppButton'
import { getLangLink, getSimpleLang } from '../helpers'
import { useDefaultComponentTools } from '../hooks/useDefaultComponentTools'
import { selectAccessToken } from '../store/redusers/auth/selectors'
import { deleteMsgAction } from '../store/redusers/user/actions'

const Loader = styled(BeatLoader)(() => ({
	margin: 'auto 16px'
}))

const SystemAlert = ({close, options, message  }) => {
	const { theme, mdDown, t, dispatch, mdUp } = useDefaultComponentTools()
	const isError = options?.type === 'error'
	const isInfo = options?.type === 'info'
	const loader = options?.loader
	const notice = options?.message
	const token = useSelector(selectAccessToken)
	const alertTitle = isInfo ? t(options?.title) : (isError ? t('Error') : t('Success'))

	const onDeleteMsg = (id) => {
		close()
		if (!token) return
		dispatch(deleteMsgAction(id, token))
	}

	return (
		<Alert
			icon={false}
			variant={'filled'}
			severity={options?.type}
			sx={{
				'.MuiAlert-message': {
					p: 0
				},
				background: isInfo ?
					'#ffff' :
					(isError ?
						theme?.palette.red || '#FF6370' :
						theme?.palette.green || '#49B073'),
				borderRadius: '8px',
				boxShadow: '0px 0px 36px rgba(0, 0, 0, 0.12)',
				color: isInfo && '#131635',
				display: 'block',
				mt: mdDown ? 1 : 2,
				p: mdDown ? '0 0 6px 8px' : '0 0 12px 16px',
				pointerEvents: 'auto',
				width: mdDown ? '200px' : '300px'
			}}
		>
			<Box sx={{ display: 'flex', justifyContent: 'end', width: '100%' }}>
				<IconButton sx={{color: isInfo ? '#000000' : '#ffffff'}}
					onClick={notice?.messageId ? () => onDeleteMsg(notice?.messageId) : close}
				>
					<CloseIcon fontSize='small'/>
				</IconButton>
			</Box>
			<Box >
				{alertTitle ?
					<AlertTitle
						sx={{ mb: mdDown ? 0.5 : 1 }}
					>
						<Typography
							variant={'px18'}
						>
							{alertTitle}
						</Typography>

					</AlertTitle> :
					null
				}
				<Box sx={{ display: 'flex', justifyContent: 'space-between', pr: '16px'}} >
					{ !notice?.messageText ? <Typography
						variant={'px16'}
						sx={{ color: isInfo && (notice ? '#131635' : theme.palette.green || '#49B073'),
							fontWeight: 500 }}
					>
						{t(message)}
					</Typography> :	<div dangerouslySetInnerHTML={{__html: message}}></div>}
					{loader &&
						<Loader margin={3}
							size={10}
							speedMultiplier={1}
							color={theme.palette.green || '#49B073'} />}
				</Box>
				{notice?.buttonLink && notice?.buttonText ?
					<AppButton link={getLangLink(notice?.buttonLink , getSimpleLang(i18n.language))}
						inputSx={{background: theme.palette.blue, height: mdUp ? '30px' : '25px', mt: '16px',
							textTransform: 'capitalize', width: '50%'
						}} title={notice?.buttonText} variant='contained'
						onClick={() => onDeleteMsg(notice?.messageId)}
					/> :
					null
				}
			</Box>
		</Alert>
	)
}

SystemAlert.propTypes = {
	close: PropTypes.func,
	message: PropTypes.string,
	options: PropTypes.object
}

export default SystemAlert
